import { AnimatePresence, motion } from "framer-motion";
import { Button } from "../components/ui/button.jsx";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

// Month variables
const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
const nextMonth = new Date(new Date().setMonth(new Date().getMonth() + 1)).toLocaleString('en-US', { month: 'long' });

type SalesBookingModalProps = {
    open: boolean;
    onClose: () => void;
    baseUrl: string,
    client: any,
};

export default function SalesBookingModal({
    open,
    onClose,
    baseUrl,
    client,
}: SalesBookingModalProps) {

    const [loading, setLoading] = useState(false);

    const [kams, setKams] = useState([]);

    const getSaleAccountManagers = async () => {
        try {
            const response = await axios.get(baseUrl + '/getSaleAgents', { params: { client_uid: client?.uid } });
            if (response.data.status === "OK") {
                setKams(response.data.data);
            }
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSaleAccountManagers();
    }, [client, baseUrl])

    // fetched days, times and durations
    const [days, setDays] = useState([]);
    const [times, setTimes] = useState([]);
    const [durations, setDurations] = useState([]);

    //selected values
    const [agent, setAgent] = useState("");
    const [month, setMonth] = useState(currentMonth);
    const [day, setDay] = useState("");
    const [time, setTime] = useState("");
    const [duration, setDuration] = useState("");
    const [interval, setInterval] = useState("");

    const [type, setType] = useState("Video");
    const [countryCode, setCountryCode] = useState("+47");
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");



    const handleAgentChanged = async (e: any) => {
        e.preventDefault();
        setAgent(e.target.value);
        let agent_uid = e.target.value;
        const response = await axios.get(baseUrl + '/getSaleAgentAvailableSlots', { params: { month: month, agent_uid: agent_uid } });
        if (response.data.status === "OK") {
            let slots = response.data.data;
            //slots.days
            setDays(slots.days);
            setDay(slots.days[0]);
            //slots.time
            setTimes(slots.times);
            setTime(slots.times[0]);
            //slots.durations
            setDurations(slots.durations);
            setDuration(slots.durations[0]);
            //slots.interval
            setInterval(slots.interval);
        }
    }

    const handleMonthChanged = async (e: any) => {
        setMonth(e.target.value);
        const response = await axios.get(baseUrl + '/getSaleAgentAvailableSlots', { params: { month: e.target.value, agent_uid: agent } })
        if (response.data.status === "OK") {
            let slots = response.data.data;
            //slots.days
            setDays(slots.days);
            setDay(slots.days[0]);
            //slots.time
            setTimes(slots.times);
            setTime(slots.times[0]);
            //slots.durations
            setDurations(slots.durations);
            setDuration(slots.durations[0]);
            //slots.interval
            setInterval(slots.interval);
        }
    }

    const handleDayChanged = async (e: any) => {
        setDay(e.target.value)
        const response = await axios.get(baseUrl + '/getSaleAgentTimes', { params: { month: month, agentId: agent, day: e.target.value, time } })
        if (response.data.status === "OK") {
            setTimes([]);
            setTimes(response.data.data);
            setTime(response.data.data[0]);
        }
    }

    const handleTimeChanged = async (e: any) => {
        setTime(e.target.value);
        const response = await axios.get(baseUrl + '/getSaleAgentDurations', { params: { month, agentId: agent, day: day, time: e.target.value } });
        if (response.data.status === "OK") {
            setDurations(response.data.data);
            setDuration(response.data.data[0]);
        }
    }

    const handleBookDemoClicked = async () => {
        try {
            setLoading(true);
            let formData = new FormData();
            formData.append("agentId", agent);
            formData.append('month', month);
            formData.append('day', day);
            formData.append('time', time);
            formData.append('duration', duration);
            formData.append('name', name.trim() + " " + lastName.trim());
            formData.append('phone', phone);
            formData.append('countryCode', countryCode);
            formData.append('email', email);
            formData.append('type', type);
            formData.append('interval', interval);
            const response = await axios.post(baseUrl + '/bookSaleSlot', formData);
            if(response.data.status === "OK"){
                onClose();
                Swal.fire({
                    title: 'Suksess',
                    icon: 'success',
                    text: response.data.data.message
                })
            }else{
                Swal.fire({
                    title: 'Failed',
                    icon: 'error',
                    text: response.data.data.message
                })
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {/* === BOOK DEMO MODAL === */}
            <AnimatePresence>
                {open && (
                    <motion.div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            initial={{ scale: 0.95, y: 10 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.95, y: 10 }}
                            className="bg-white rounded-2xl w-full max-w-md p-6 relative"
                        >
                            <button
                                onClick={onClose}
                                className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
                                aria-label="Close"
                            >
                                ✕
                            </button>

                            <h3 className="text-3xl font-semibold text-slate-900 mb-6">
                                Book demo
                            </h3>

                            {loading && (
                                <div className="flex items-center justify-center h-64">
                                    <div className="flex flex-col items-center">
                                        <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                                        <p className="mt-3 text-gray-600 animate-pulse">Laster ...</p>
                                    </div>
                                </div>
                            )}

                            {!loading && (
                                <>
                                    {/* UI-only booking form */}
                                    <div className="space-y-0">
                                        <div>
                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                Velg rådgiver
                                            </label>
                                            <select defaultValue={""} onChange={(e) => handleAgentChanged(e)} className="w-full rounded-xl border border-slate-300 px-4 py-3 focus:ring-orange-500">
                                                <option value="">Velg agent</option>
                                                {kams.map((kam) => (
                                                    <option value={kam.uid}>{kam.name}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                Dato og tidspunkt
                                            </label>
                                            <div className="grid grid-cols-3 gap-2">
                                                <select required onChange={(e) => handleMonthChanged(e)} className="rounded-xl border px-3 py-3">
                                                    <option value={currentMonth}>{currentMonth}</option>
                                                    <option value={nextMonth}>{nextMonth}</option>
                                                </select>
                                                <select required defaultValue={day} onChange={(e) => handleDayChanged(e)} className="rounded-xl border px-3 py-3">
                                                    {days.map((dy) => (
                                                        <option value={dy}>{dy}</option>
                                                    ))}
                                                </select>
                                                <select required defaultValue={time} onChange={(e) => handleTimeChanged(e)} className="rounded-xl border px-3 py-3">
                                                    {times.map((time) => (
                                                        <option value={time}>{time}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                Duration (min)
                                            </label>
                                            <select required className="rounded-xl w-full border px-3 py-3">
                                                {durations.length === 0 && <option>No slots available</option>}
                                                {durations.map((duration) => (
                                                    <option value={duration}>{duration}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                Navn
                                            </label>
                                            <div className="grid grid-cols-2 gap-2">
                                                <input onChange={(e) => setName(e.target.value)} required placeholder="Fornavn" className="rounded-xl border px-4 py-3" />
                                                <input onChange={(e) => setLastName(e.target.value)} placeholder="Etternavn" className="rounded-xl border px-4 py-3" />
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                Telefon
                                            </label>
                                            <div className="grid grid-cols-[90px_1fr] gap-2">
                                                <select onChange={(e) => setCountryCode(e.target.value)} required className="rounded-xl border px-3 py-3">
                                                    <option>+47</option>
                                                    <option>+46</option>
                                                    <option>+45</option>
                                                </select>
                                                <input onChange={(e) => setPhone(e.target.value)} required placeholder="12345678" className="rounded-xl border px-4 py-3" />
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-slate-700 mb-1">
                                                E-post
                                            </label>
                                            <input onChange={(e) => setEmail(e.target.value)} required placeholder="din@epost.no" className="w-full rounded-xl border px-4 py-3" />
                                        </div>
                                    </div>

                                    <button
                                        onClick={handleBookDemoClicked}
                                        className="mt-6 w-full rounded-2xl text-white px-5 py-2 shadow hover:brightness-90"
                                        style={{ backgroundColor: "var(--primary-color)" }}
                                    >
                                        Book demo
                                    </button>
                                </>
                            )}

                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}